// extracted by mini-css-extract-plugin
export var billingAddress = "_y2-g";
export var contactInfo = "_y2-d";
export var customerInfoContainer = "_y2-c";
export var customerInfoContainerMobile = "_y2-h";
export var customerInfoRow = "_y2-a";
export var customerInfoSection = "_y2-b";
export var fullWidthDividerMobile = "_y2-i";
export var imageContainer = "_y2-1";
export var paymentMethod = "_y2-e";
export var priceText = "_y2-6";
export var priceTextMobile = "_y2-7";
export var product = "_y2-0";
export var productImage = "_y2-2";
export var productInfo = "_y2-4";
export var productMobile = "_y2-9";
export var productTitle = "_y2-8";
export var quantityBadge = "_y2-3";
export var quantityText = "_y2-5";
export var shippingAddress = "_y2-f";